export default {
  data() {
    return {
      selectArr: [],
      approvalSetDep: {},
      nowFlowSource: {
        key1: '',
        key2: ''
      },

      approvalUsers: {
        // 使用/外带印章
        c0: [{
          name: "需求单位审批",
          users: ["分管领导", "分管副总", "总经理"]
        }],
        // 刻制/销毁印章
        c1: [{
          name: "需求单位审批",
          users: ["申请部门(单位负责人)", "行政事务部", "分管副总"]
        }],
        // 项目申请 （工程项目）
        c2_0: [{
          name: "需求单位审批",
          users: ["分管副总", "总经理"]
        }, {
          name: "集团审批",
          users: ["战略企划部", "分管副总", "总经理"]
        }],
        // 项目申请 （原水）
        c2_1: [{
          name: "需求单位审批",
          users: ["分管副总", "工程运行部", "总经理"]
        }, {
          name: "集团审批",
          users: ["战略企划部", "分管副总", "总经理"]
        }],
        // 项目申请 （其他项目）
        c2_2: [{
          name: "需求单位审批",
          users: ["分管副总", "总经理"]
        }, {
          name: "集团审批",
          users: ["战略企划部", "分管副总", "总经理"]
        }],
        // 项目申请 （微型项目）
        c2_3: [{
          name: "需求单位审批",
          users: ["实施科室", "分管副总", "计划财务部", "总经理"]
        }, {
          name: "集团备案",
          users: ["战略企划部"]
        }],
        // 项目申请 （原水微型项目）
        c2_4: [{
          name: "需求单位审批",
          users: ["分公司经理", "工程运行部", "计划财务部", "总经理"]
        }, {
          name: "集团备案",
          users: ["战略企划部"]
        }],
        // 项目申请 （集团）
        c2_5: [{
          name: "集团审批",
          users: ["部门负责人", "战略企划部", "分管副总", "总经理"]
        }],

        // 招标控制价（通用审批）
        c4_0: [{
          name: "实施单位意见",
          users: ["造价负责人", "负责人"]
        }, {
          name: "内控法务部",
          users: ["审核人", "负责人"]
        }, {
          name: "集团审批意见",
          users: ["分管副总", "财务部备案"]
        }],
        // 招标控制价（原水审批）
        c4_1: [{
          name: "申报单位",
          users: ["分管副总", "工程运行部", "总经理"]
        }, {
          name: "内控法务部",
          users: ["审核人", "负责人"]
        }, {
          name: "集团审批意见",
          users: ["分管副总", "财务部备案"]
        }],
        // 招标控制价（一户一表）
        c4_2: [{
          name: "实施单位意见",
          users: ["造价负责人", "负责人"]
        }, {
          name: "内控法务部",
          users: ["审核人", "负责人"]
        }, {
          name: "集团审批意见",
          users: ["分管副总", "财务部备案"]
        }],
        // 预算（招标控制价）审批
        c4_3: [{
          name: "实施单位意见",
          users: ["造价审核部门", "分管副总", "总经理"]
        }, {
          name: "水务集团备案",
          users: ["内控法务部"]
        }],
        // 预算（招标控制价）审批(原水)
        c4_4: [{
          name: "实施单位意见",
          users: ["分公司经理", "工程运行部", "总经理"]
        }, {
          name: "水务集团备案",
          users: ["内控法务部"]
        }],

        // 招标文件会签
        c10_0: [{
          name: "项目相关单位",
          users: ["需求单位"]
        }, {
          name: "资产运营部",
          users: ["审核人", "负责人"]
        }, {
          name: "工程技术中心",
          users: ["审核人"]
        }, {
          name: "内控法务部",
          users: ["审核人"]
        }, {
          name: "财务总监",
          users: ["负责人"]
        }, {
          name: "领导小组",
          users: ["招标领导小组办公室", "招标领导小组", "监管小组"]
        }],
        c10_1: [{
          name: "需求单位意见",
          users: ["经办人", "部门负责人", "副总经理", "总经理"]
        }],


        // 合同备案
        c11_0: [{
          name: "需求单位审批",
          users: ["分管副总", "总经理"]
        }, {
          name: "审核主体",
          users: ["资产运营部/战略企划部/内控法务部", "财务总监", "集团分管副总"]
        }],
        // 合同会签（集团）
        c11_1: [{
          name: "需求单位审批",
          users: ["承办人", "承办单位负责人"]
        }, {
          name: "审核主体",
          users: ["相关业务部门", "内控法务部", "财务管理部", "财务总监", "分管副总", "总经理"]
        }],
        // 合同会签 (子公司)
        c11_2: [{
          name: "需求单位审批",
          users: ["承办人", "承办部门负责人"]
        }, {
          name: "审核主体",
          users: ["综合管理部", "计划财务部", "分管副总", "总经理"]
        }],
        // 合同会签 (原水)
        c11_3: [{
          name: "需求单位审批",
          users: ["承办人", "承办部门负责人"]
        }, {
          name: "审核主体",
          users: ["工程运行部", "计划财务部", "总经理"]
        }],

        // 进度款审核
        c5_0: [{
          name: "实施单位意见",
          users: ["审核人", "分管副总"]
        }, {
          name: "水务集团",
          users: ["战略企划部", "分管领导"]
        }],
        // 进度款审核（原水）
        c5_1: [{
          name: "审核意见",
          users: ["审核人", "复核人"]
        }, {
          name: "水务集团",
          users: ["战略企划部", "分管领导"]
        }],

        // // 进度款支付
        // c6: [{
        //   name: "付款单位",
        //   users: ["付款单位财务部"]
        // }, {
        //   name: "水务集团",
        //   users: ["战略企划部", "集团财务总监", "分管副总"]
        // }],
        // // 结算款支付
        // c8: [{
        //   name: "付款单位",
        //   users: ["付款单位财务部"]
        // }, {
        //   name: "水务集团",
        //   users: ["战略企划部", "集团财务总监", "分管副总"]
        // }],

        // 集团支付
        c14_0: [{
          name: "项目管理单位",
          users: ["部门负责人", "分管副总"]
        }, {
          name: "付款单位",
          users: ["财务部", "总经理"]
        }, {
          name: "水务集团",
          users: ["相关部门(资产运营部/战略企划部)", "集团财务总监", "分管副总"]
        }],
        // 原水支付
        c14_1: [{
          name: "项目管理单位",
          users: ["项目负责人", "工程运行部"]
        }, {
          name: "付款单位",
          users: ["财务部", "总经理"]
        }, {
          name: "水务集团",
          users: ["相关部门(资产运营部/战略企划部)", "集团财务总监", "分管副总"]
        }],
        // 子公司支付
        c14_2: [{
          name: "项目管理单位",
          users: ["部门负责人", "计划财务部", "分管副总", "总经理"]
        }],
        // 原水子公司支付
        c14_3: [{
          name: "项目管理单位",
          users: ["项目负责人", "工程运行部", "财务部", "单位负责人"]
        }],
        // 集团内部支付审批
        c14_4: [{
          name: "水务集团",
          users: ["经办部门负责人", "财务部", "财务总监", "分管副总", "总经理"]
        }],
        // 设备与采购
        c14_5: [{
          name: "付款单位",
          users: ["部门主管", "分管副总", "计划财务部", "财务总监", "总经理"]
        }],
        // 资金使用申请(原水)
        c14_6: [{
          name: "申请单位",
          users: ["申请单位负责人"]
        }, {
          name: "原水公司",
          users: ["财务管理部", "负责人"]
        }],


        // 项目预警时间
        c13: [{
          name: "需求/施工单位审批",
          users: ["相关单位负责人"]
        }, {
          name: "集团审批",
          users: ["战略企划部", "分管副总"]
        }],


        // 合同
        // 招标文件会签
        c30_0: [{
          name: "项目相关单位",
          users: ["需求单位"]
        }, {
          name: "实施单位",
          users: ["审核人", "负责人"]
        }, {
          name: "战略企划部",
          users: ["审核人"]
        }, {
          name: "内控法务部",
          users: ["审核人"]
        }, {
          name: "财务总监",
          users: ["负责人"]
        }, {
          name: "领导小组",
          users: ["招标领导小组办公室", "招标领导小组", "监管小组"]
        }],
        c30_1: [{
          name: "需求单位意见",
          users: ["经办人", "部门负责人", "副总经理", "总经理"]
        }],
        // 合同备案
        c31_0: [{
          name: "需求单位审批",
          users: ["分管副总", "总经理"]
        }, {
          name: "审核主体",
          users: ["相关部门(资产运营部/战略企划部/内控法务部)", "财务总监", "集团分管副总"]
        }],
        // 合同会签（集团）
        c31_1: [{
          name: "需求单位审批",
          users: ["承办人", "承办单位负责人"]
        }, {
          name: "审核主体",
          users: ["相关部门", "内控法务部", "财务管理部", "财务总监", "分管副总", "总经理"]
        }],
        // 合同会签 (子公司)
        c31_2: [{
          name: "需求单位审批",
          users: ["承办人", "承办部门负责人"]
        }, {
          name: "审核主体",
          users: ["综合管理部", "计划财务部", "分管副总", "总经理"]
        }],
        // 合同会签 (原水)
        c31_3: [{
          name: "需求单位审批",
          users: ["承办人", "承办部门负责人"]
        }, {
          name: "审核主体",
          users: ["工程运行部/综合管理部", "计划财务部", "总经理"]
        }],
        // 进度款审核
        c33: [{
          name: "实施单位意见",
          users: ["审核人", "复核人", "分管领导"]
        }],


        // 项目付款集团支付
        c32_0: [{
          name: "项目管理单位",
          users: ["部门负责人", "分管副总"]
        }, {
          name: "付款单位",
          users: ["财务部", "单位负责人"]
        }, {
          name: "水务集团",
          users: ["相关部门(资产运营部/战略企划部)", "集团财务总监", "分管副总"]
        }],
        // 原水支付
        c32_1: [{
          name: "项目管理单位",
          users: ["项目负责人", "工程运行部"]
        }, {
          name: "付款单位",
          users: ["财务部", "单位负责人"]
        }, {
          name: "水务集团",
          users: ["相关部门(资产运营部/战略企划部)", "集团财务总监", "分管副总"]
        }],
        // 子公司支付
        c32_2: [{
          name: "项目管理单位",
          users: ["部门负责人", "计划财务部", "分管副总", "总经理"]
        }],
        // 原水子公司支付
        c32_3: [{
          name: "项目管理单位",
          users: ["项目负责人", "工程运行部", "财务部", "单位负责人"]
        }],
        // 集团内部支付审批
        c32_4: [{
          name: "水务集团",
          users: ["经办部门负责人", "财务部", "财务总监", "分管副总", "总经理"]
        }],
        // 设备与采购
        c32_5: [{
          name: "付款单位",
          users: ["部门主管", "分管副总", "计划财务部", "财务总监", "总经理"]
        }],
        // 资金使用申请(原水)
        c32_6: [{
          name: "申请单位",
          users: ["申请单位负责人"]
        }, {
          name: "原水公司",
          users: ["财务管理部", "负责人"]
        }],



        // 仓库材料领用
        c50: [{
          name: "项目管理单位",
          users: ["单位负责人"]
        }],

        // 易耗品
        c61: [{
          name: "采购计划",
          users: ["默认负责人"]
        }],
        c63: [{
          name: "领用申请",
          users: ["默认负责人"]
        }],
        c64: [{
          name: "退库申请",
          users: ["默认负责人"]
        }],

        // 采购相关
        c70_0: [{
          name: "水务集团",
          users: ["部门负责人", "战略企划部", "资产运营部<br/>采购主管", "资产运营部部长", "分管副总", "总经理"]
        }],
        c70_1: [{
          name: "相关单位审批",
          users: ["部门负责人", "单位负责人", ]
        }, {
          name: "水务集团",
          users: ["战略企划部", "资产运营部<br/>采购主管", "资产运营部部长", "分管副总", "总经理"]
        }],
        c70_2: [{
          name: "相关单位审批",
          users: ["申购部门负责人", "相关部门负责人", "分管副总", "总经理"]
        }],
        c71_0: [{
          name: "水务集团",
          users: ["部门负责人", "资产运营部"]
        }],
        c71_1: [{
          name: "相关单位审批",
          users: ["部门负责人", "单位负责人"]
        }, {
          name: "水务集团",
          users: ["资产运营部"]
        }],


        // 车辆相关审批
        c80: [{
          name: "相关部门/单位审批",
          users: ["部门/子公司负责人", ]
        }, {
          name: "水务集团",
          users: ["行政事务部", "分管副总", "总经理", ]
        }],
        c81: [{
          name: "水务集团",
          users: ["行政事务部主管", "行政事务部部长"]
        }],
        c82: [{
          name: "相关单位",
          users: ["综合管理部", ]
        }, {
          name: "水务集团",
          users: ["分管副总", ]
        }],
        c83: [{
          name: "相关单位",
          users: ["综合管理部", "分管副总"]
        }],
        c84: [{
          name: "相关单位/部门",
          users: ["经办人", "单位/部门负责人"]
        }, {
          name: "水务集团",
          users: ["行政事务部", "分管副总", ]
        }],
        c85: [{
          name: "水务集团",
          users: ["行政事务部", "分管副总", ]
        }],
        c86: [{
          name: "相关单位",
          users: ["综合管理部"]
        }],
        c87: [{
          name: "相关单位",
          users: ["综合管理部", "分管副总"]
        }],
        c88: [{
          name: "验收核对",
          users: ["验收人员", ]
        }],
        c89: [{
          name: "相关单位",
          users: ["部门负责人", "行政事务部<br/>综合管理部", "分管副总"]
        }],
        c90: [{
          name: "水务集团",
          users: ["行政事务部", "财务管理部", "分管副总", "总经理", ]
        }],
        c91: [{
          name: "相关单位",
          users: ["综合管理部", "分管副总", "总经理"]
        }],


        c101: [{
          name: "相关领导",
          users: ["部门负责人", "人力资源部<br/>综合管理部", "分管领导", "总经理", ]
        }],
        c102: [{
          name: "相关单位",
          users: ["调出公司/集团<br/>部门意见", "调入公司/集团<br/>部门意见", ]
        }, {
          name: "水务集团",
          users: ["人力资源部", "分管副总", "总经理", ]
        }],


        c110: [{
          name: "相关单位",
          users: ["部门负责人", "资产运营部", "财务管理部", "分管副总", ]
        }, ],
        c111: [{
          name: "相关单位",
          users: ["部门负责人", "资产运营部", "财务管理部", "分管副总", ]
        }, ],

        c120: [{
          name: "审批单位",
          users: ["需求单位", "材料采购小组", "分管副总", ]
        }, ],

        c130: [{
          name: "相关部门",
          users: ["行政事务部<br/>综合管理部", ]
        }, ],


      },
    }
  },
  methods: {
    getApprovalUsers(key1, key2) {
      console.log(key1, key2)
      this.nowFlowSource = {
        key1: key1,
        key2: key2
      }

      this.selectArr = []

      let aUser = this.approvalUsers['c' + key1]
      if (key2 || key2 === 0) {
        aUser = this.approvalUsers['c' + key1 + '_' + key2]
      }
      if (!aUser) {
        return
      }
      // console.log(aUser)
      for (var i = 0; i < aUser.length; i++) {
        for (var j = 0; j < aUser[i].users.length; j++) {
          this.$set(this.selectArr, 'arr_' + i + "_" + j, [])
        }
      }

      ajax.post('/user/approval/users/log', {
        flowSource: key1,
        flowSourceType: key2,
      }, (res) => {
        // 有设置log且flowSource都还对的上
        if (res.vo.approvalIds && (this.nowFlowSource.key1 == res.vo.flowSource && this.nowFlowSource.key2 == res.vo.flowSourceType)) {
          let approvals = res.vo.approvals
          for (var i = 0; i < approvals.length; i++) {
            if (approvals[i].user) {
              this.setArr(aUser, i, approvals[i].user)
            } else {
              this.setDep(aUser, i, approvals[i].depId)
            }
          }
        } else {
          console.log(this.nowFlowSource.key1, res.vo.flowSource, this.nowFlowSource.key2, res.vo.flowSourceType)
        }

      })
    },
    setDep(aUser, index, depId) {
      let count = 0
      for (var i = 0; i < aUser.length; i++) {
        for (var j = 0; j < aUser[i].users.length; j++) {
          if (count == index) {
            this.approvalSetDep['arr_' + i + "_" + j] = depId
            return
          }
          count++
        }
      }
    },
    setArr(aUser, index, user) {
      let count = 0
      for (var i = 0; i < aUser.length; i++) {
        for (var j = 0; j < aUser[i].users.length; j++) {
          if (count == index) {
            let _tempArr = this.selectArr['arr_' + i + "_" + j]
            // 强制使审批人变成一个人
            _tempArr = []
            // 添加当前选择的人
            _tempArr.push(user)
            this.$set(this.selectArr, 'arr_' + i + "_" + j, _tempArr)
            return
          }
          count++
        }
      }
    },
    setSelectArr(applyInfo, key1, key2) {

      console.log('setSelectArr', key1, key2, applyInfo)

      let approvals = ''
      let aUser = this.approvalUsers['c' + key1]
      if (key2 || key2 === 0) {
        aUser = this.approvalUsers['c' + key1 + '_' + key2]
      }
      if (applyInfo) {
        approvals = this.applyInfo.flow.approvals

        let count = 0
        for (var i = 0; i < aUser.length; i++) {
          // console.log(aUser[i].users)
          for (var j = 0; j < aUser[i].users.length; j++) {

            let _tempArr = []
            this.$set(this.selectArr, 'arr_' + i + "_" + j, _tempArr)

            if (approvals && approvals[count] && approvals[count].user) {
              _tempArr.push(approvals[count].user)
              this.$set(this.selectArr, 'arr_' + i + "_" + j, _tempArr)
            }
            count++
          }
        }
      } else {
        this.getApprovalUsers(key1, key2)
      }
      console.log(this.selectArr)
    },
  }
}



// WEBPACK FOOTER //
// ./src/Mixins/approvalUsers.js